// extracted by mini-css-extract-plugin
export default {"title":"NNIXbDlS7n","item":"nooiHAgLqL","description":"Lthm8MeLbt"};